import React from "react";
import { EyeOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useEnrollmentTracking } from "../hooks/useEnrollmentTracking";

const ViewApplicationFormActionButton = ({ onClick, type = "text", text }) => {
  const { trackIconClick } = useEnrollmentTracking();

  const handleClick = () => {
    trackIconClick("view_form_icon_button", {
      button_id: "EE_view_application_form",
      button_text: text || "View"
    });
    onClick();
  };

  return (
    <Button
      id="EE_view_application_form"
      type={type}
      icon={<EyeOutlined style={{ fontSize: "20px" }} />}
      onClick={handleClick}
      style={{ ...(text && { padding: "4px 8px" }) }}
    >
      {text}
    </Button>
  );
};

export default ViewApplicationFormActionButton;
